<template>
	<div class="empoyee">
		<form class="empoyee__wrapper"
      @submit.prevent="comfirm"
      novalidate>
			<div class="empoyee__title"
        v-if="(typeAction === 'company' || typeAction === 'company user') && edit === false">
				{{ typeEmployee }}
			</div>
			<div class="empoyee__block">
				<div class="empoyee__block__wrapper">

					<div class="empoyee__block__item empoyee__block__item--img"
            v-if="typeAction === 'company'">
						<div class="empoyee__block__img">
							<span class="empoyee__block-title">{{ $t('forms.companyLogo') }}</span>
							<label class="empoyee__img"
                :style="[dataUser.big_company_image ? {backgroundImage: 'url(' + dataUser.big_company_image +')'} : {}]">
								<input type="file"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="updateCompanyImg">
								<span class="placeholder"
                  v-if="dataUser.big_company_image"></span>
							</label>
						</div>
						<div class="empoyee__block__img">
							<span class="empoyee__block-title">{{ $t('forms.ownerLogo') }}</span>
							<label class="empoyee__img"
                :style="[dataUser.big_image ? {backgroundImage: 'url(' + dataUser.big_image +')'} : {}]">
								<input type="file"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="updateEmployeeImg">
								<span class="placeholder"
                  v-if="dataUser.big_image"></span>
							</label>
						</div>
					</div>

					<div class="empoyee__block__item empoyee__block__item--img"
            v-if="typeAction === 'company user'">
						<div class="empoyee__block__img empoyee__block__img--single">
							<label class="empoyee__img"
                :style="[dataUser.big_image ? {backgroundImage: 'url(' + dataUser.big_image +')'} : {}]">
								<input type="file"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="updateEmployeeImg">
								<span class="placeholder"
                  v-if="dataUser.big_image"></span>
							</label>
							<span class="small-logo"
                :style="[companyImage ? {backgroundImage: 'url(' + companyImage +')'} : {}]"></span>
						</div>
					</div>
					<template v-if="typeAction === 'company'">
						<div class="empoyee__block__item empoyee__block__item--post">

							<label :data-error="$t('errors.name')"
                :class="{'error-input' : errors.has('company_name'), 'success-input' :  fields.company_name && fields.company_name.touched && fields.company_name.valid}">
								<input type="text"
                  class="form-input"
                  :placeholder="$t('forms.companyName')"
                  v-validate="{required: true, min: 1, max: 16}"
                  name="company_name"
                  v-model="dataUser.company_name">
							</label>

						</div>
						<div class="empoyee__block__item empoyee__block__item--name">
							<label :data-error="$t('errors.name')"
                :class="{'error-input' : errors.has('first_name'), 'success-input' :  fields.first_name && fields.first_name.touched && fields.first_name.valid}">

								<input type="text"
                  class="form-input"
                  :placeholder="$t('forms.ownerName')"
                  v-validate="{required: true, min: 1, max: 16}"
                  name="first_name"
                  v-model="dataUser.first_name">
							</label>
						</div>
						<div class="empoyee__block__item empoyee__block__item--lastname">
							<label :data-error="$t('errors.name')"
                :class="{'error-input' : errors.has('last_name'), 'success-input' :  fields.last_name && fields.last_name.touched && fields.last_name.valid}">
								<input type="text"
                  class="form-input"
                  :placeholder="$t('forms.ownerSurname')"
                  v-validate="{required: true, min: 1, max: 16}"
                  name="last_name"
                  v-model="dataUser.last_name">
							</label>
						</div>
					</template>
					<template v-else>
						<div class="empoyee__block__item empoyee__block__item--name">
							<label :data-error="$t('errors.name')"
                :class="{'error-input' : errors.has('first_name_e'), 'success-input' :  fields.first_name_e && fields.first_name_e.touched && fields.first_name_e.valid}">
								<input type="text"
                  class="form-input"
                  :placeholder="$t('forms.name')"
                  v-validate="{required: true, min: 1, max: 16}"
                  name="first_name_e"
                  required
                  v-model="dataUser.first_name">
							</label>
						</div>
						<div class="empoyee__block__item empoyee__block__item--lastname">
							<label :data-error="$t('errors.name')"
                :class="{'error-input' : errors.has('last_name_e'), 'success-input' :  fields.last_name_e && fields.last_name_e.touched && fields.last_name_e.valid}">
								<input type="text"
                  class="form-input"
                  :placeholder="$t('forms.ownerSurname')"
                  required
                  v-validate="{required: true, min: 1, max: 16}"
                  name="last_name_e"
                  v-model="dataUser.last_name">
							</label>
						</div>
						<div class="empoyee__block__item empoyee__block__item--post">
							<label :data-error="$t('errors.required')"
                :class="{'error-input' : errors.has('post'), 'success-input' :  fields.post && fields.post.touched && fields.post.valid}">
								<input type="text"
                  class="form-input"
                  :placeholder="$t('forms.post')"
                  required
                  v-validate="{required: true}"
                  name="post"
                  v-model="dataUser.post">
							</label>
						</div>
					</template>
					<div class="empoyee__block__item empoyee__block__item--phone">
						<label :data-error="$t('errors.phone')"
              :class="{'error-input' : errors.has('phone'), 'success-input' :  fields.phone && fields.phone.touched && fields.phone.valid}">
							<input
                class="form-input"
                :placeholder="$t('forms.phone')"
                v-validate="{required: true, regex: /([0-9])|(\+)/}"
								type="text"
                name="phone"
                autocomplete="off"
                v-model="dataUser.phone">
						</label>
					</div>
					<div class="empoyee__block__item empoyee__block__item--mail">
						<label :data-error="$t('errors.email')"
              :class="{'error-input' : errors.has('email'), 'success-input' :  fields.email && fields.email.touched && fields.email.valid}">
							<input type="email"
                class="form-input"
                placeholder="Email"
                v-validate="{required: true, email: true}"
                name="email"
                v-model="dataUser.email">
						</label>
					</div>
					<div class="empoyee__block__item empoyee__block__item--country">
						<label :data-error="$t('errors.required')"
              :class="{'error-input' : errors.has('country'), 'success-input' :  fields.country && fields.country.touched && fields.country.valid}">
							<input type="text"
                class="form-input"
                :placeholder="$t('forms.country')"
                v-validate="{required: true}"
                name="country"
                v-model="dataUser.address.country">
						</label>

					</div>
					<div class="empoyee__block__item empoyee__block__item--city">
						<label :data-error="$t('errors.required')"
              :class="{'error-input' : errors.has('city'), 'success-input' :  fields.city && fields.city.touched && fields.city.valid}">
							<input type="text"
                class="form-input"
                :placeholder="$t('forms.city')"
                v-validate="{required: true}"
                name="city"
                v-model="dataUser.address.city">
						</label>
					</div>
					<div class="empoyee__block__item ">
						<label :data-error="$t('errors.required')"
              :class="{'error-input' : errors.has('street'), 'success-input' :  fields.street && fields.street.touched && fields.street.valid}">
							<input type="text"
                class="form-input"
                :placeholder="$t('forms.street')"
                v-validate="{required: true}"
                name="street"
                v-model="dataUser.address.street">
						</label>
					</div>
					<div class="empoyee__block__item empoyee__block__item--house">
						<label :data-error="$t('errors.required')"
              :class="{'error-input' : errors.has('house'), 'success-input' :  fields.house && fields.house.touched && fields.house.valid}">
							<input type="text"
                class="form-input"
                :placeholder="$t('forms.house')"
                v-validate="{required: true}"
                name="house"
                v-model="dataUser.address.house">
						</label>
					</div>
					<div class="empoyee__block__item empoyee__block__item--entrance">
						<label :data-error="$t('errors.required')"
              :class="{'error-input' : errors.has('entrance'), 'success-input' :  fields.entrance && fields.entrance.touched && fields.entrance.valid}">
							<input type="text"
                class="form-input"
                :placeholder="$t('forms.entrance')"
                v-validate="{required: true}"
                name="entrance"
                v-model="dataUser.address.entrance">
						</label>
					</div>
					<div class="empoyee__block__item empoyee__block__item--apartment">
						<label :data-error="$t('errors.required')"
              :class="{'error-input' : errors.has('apartment'), 'success-input' :  fields.apartment && fields.apartment.touched && fields.apartment.valid}">
							<input type="text"
                class="form-input"
                :placeholder="$t('forms.office')"
                v-validate="{required: true}"
                name="apartment"
                v-model="dataUser.address.apartment">
						</label>
					</div>
					<div class="empoyee__block__item "
            :class=" { 'empoyee__block__item--w100p' : !transfer } ">
						<label :data-error="$t('errors.required')"
              :class="{'error-input' : errors.has('description'), 'success-input' :  fields.description && fields.description.touched && fields.description.valid}">
							<input type="text"
                class="form-input"
                :placeholder="$t('forms.description')"
                v-validate="{required: true}"
                name="description"
                v-model="dataUser.address.description">
						</label>
					</div>
					<div class="empoyee__block__item"
            v-if="transfer">
						<label :data-error="$t('errors.passwordLength')"
              :class="{'error-input' : errors.has('password'), 'success-input' :  fields.password && fields.password.touched && fields.password.valid}">
							<input type="password"
                class="form-input"
                :placeholder="$t('forms.passEnter')"
                v-validate="{min:4}"
                autocomplete="off"
                name="password"
                v-model.trim="dataUser.password">
						</label>
					</div>
					<div class="empoyee__block__item"
            v-if="!transfer">
						<div :data-error="$t('errors.passwordLength')"
              :class="{'error-input' : errors.has('passwordAdd'), 'success-input' :  fields.passwordAdd && fields.passwordAdd.touched && fields.passwordAdd.valid}">
							<input type="password"
                class="form-input"
                :placeholder="$t('forms.comeUpPass')"
                v-validate="{min:4, required: !edit}"
                name="passwordAdd"
                autocomplete="off"
                v-model.trim="dataUser.password">
						</div>
					</div>
					<div class="empoyee__block__item"
            v-if="!transfer">
						<div :data-error="$t('errors.password')"
              :class="{'error-input' : errors.has('confirmPassword'), 'success-input' :  fields.confirmPassword && fields.confirmPassword.touched && fields.confirmPassword.valid}">
							<input type="password"
                v-if="edit"
                class="form-input"
                :placeholder="$t('forms.comeUpPassAgain')"
                v-validate="'confirmed:passwordAdd|min:4'"
                name="confirmPassword"
                autocomplete="off"
                v-model.trim="dataUser.passwordConfirm">
							<input type="password"
                v-else
                class="form-input"
                :placeholder="$t('forms.comeUpPassAgain')"
                v-validate="'confirmed:passwordAdd|min:4|required'"
                name="confirmPassword"
                autocomplete="off"
                v-model.trim="dataUser.passwordConfirm">
						</div>
					</div>
				</div>
			</div>
			<div class="empoyee__buttons">
				<button class="button"
          type="button"
          @click="close">
					{{$t('global.cancel')}}
				</button>
				<button class="button"
          type="submit"
          :disabled="!passwordValid">
					<span v-if="edit">{{$t('global.edit')}}</span>
					<span v-else>{{$t('global.add')}}</span>
				</button>
			</div>
		</form>
		<template v-if="requestState"></template>
	</div>
</template>

<script>
export default {
    props: [
        'typeAction',
        'typeEmployee',
        'edit',
        'okAction',
        'cancelAction',
        'dataEmployee',
        'updateAvatar',
        'setCompanyAvatar',
        'updateCompanyAvatar',
        'request',
        'companyId',
        'companyImage',
        'transfer',
    ],

    data() {
        return {
            data: [],
        }
    },
    methods: {
        updateEmployeeImg(event) {
            const files = event.target.files[0]
            const formData = new FormData()
            if (files) {
                const reader = new FileReader()
                reader.readAsDataURL(files)
                reader.onload = () => {
                    this.$emit('setAvatar', reader.result, this.typeAction)
                }
            }
            formData.append('image', files)
            this.$emit('updateAvatar', formData)
        },

        updateCompanyImg(event) {
            const files = event.target.files[0]
            const formData = new FormData()
            if (files) {
                const reader = new FileReader()
                reader.readAsDataURL(files)
                reader.onload = () => {
                    this.$emit('setCompanyAvatar', reader.result)
                }
            }
            formData.append('image', files)
            this.$emit('updateCompanyAvatar', formData)
        },
        close() {
            this.$emit('cancelAction')
        },
        comfirm() {
            this.$validator.validate().then((valid) => {
                if (valid) this.$emit('okAction')
            })
        },
    },
    computed: {
        dataUser() {
            return this.dataEmployee
        },
        requestState() {
            if (this.request === 'success') {
                this.$emit('cancelAction')
            }
            return this.request
        },
        passwordValid() {
            if (this.dataUser.password === this.dataUser.passwordConfirm && this.transfer === false) {
                return true
            } else return !!this.transfer
        },
        type() {
            return this.typeAction === 'company'
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'src/assets/sass/main';
.empoyee {
	max-width: 725px;
	padding: 64px;
	@include respond(smallhight) {
		padding: 30px 40px;
	}

	&__wrapper {
	}
	&__title {
		font-size: 36px;
		color: $primaryColor;
		font-family: $fontMedium;
		text-align: center;
		margin-bottom: 68px;
		@include respond(smallhight) {
			font-size: 30px;
			margin-bottom: 40px;
		}
	}
	&__block {
		margin-bottom: 64px;
		@include respond(smallhight) {
			margin-bottom: 30px;
		}
		&__wrapper {
			& .form-input {
				margin-bottom: 16px;
				box-sizing: border-box;
				width: 100%;

				&--w100p {
					margin-bottom: 16px;
				}
			}
		}
		&__item {
			width: calc(50% - 18px);
			box-sizing: border-box;
			margin-left: 8px;
			margin-right: 8px;
			display: inline-block;

			&--w100p {
				width: calc(100% - 16px);
				@include respond(smallhight) {
					width: calc(50% - 18px);
				}
			}
			&--img {
				display: flex;
				justify-content: center;
				float: left;
				@include respond(smallhight) {
					width: calc(33.333% - 18px);
				}
			}
			&--name {
				@include respond(smallhight) {
					width: calc(33.333% - 18px);
				}
			}
			&--lastname {
				@include respond(smallhight) {
					width: calc(33.333% - 18px);
				}
			}
			&--phone {
				@include respond(smallhight) {
					width: calc(33.333% - 18px);
				}
			}
			&--mail {
				@include respond(smallhight) {
					width: calc(33.333% - 18px);
				}
			}
			&--post {
				@include respond(smallhight) {
					width: calc(66.666% - 18px);
				}
			}
			&--city {
				@include respond(smallhight) {
					width: calc(25% - 18px);
				}
			}
			&--country {
				@include respond(smallhight) {
					width: calc(25% - 18px);
				}
			}
			&--apartment {
				width: calc(16.66666% - 19px);
			}
			&--entrance {
				width: calc(16.66666% - 19px);
			}
			&--house {
				width: calc(16.66666% - 19px);
			}
		}
		&-title {
			font-size: 12px;
			color: #4d4d4d;
			max-width: 100px;
			display: inline-block;
			margin-bottom: 13px;
			text-align: center;
		}
		&__img {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			margin-right: 36px;
			margin-bottom: 10px;
			position: relative;
			@include respond(smallhight) {
				margin-right: 12px;
			}

			&--single {
				& .empoyee__img {
					width: 179px;
					height: 179px;
				}
				& .small-logo {
					position: absolute;
					bottom: -10px;
					right: 5px;
					width: 44px;
					height: 44px;
					border: solid 1px #fcee21;
					border-radius: 50%;
					background-color: #ffffff;
					background-image: url('/images/icon/company-logo.png');
					background-size: cover;
					background-position: center;
				}
			}
		}
	}
	&__img {
		display: block;
		position: relative;
		align-self: center;
		width: 137px;
		height: 137px;
		border-radius: 50%;

		border: 2px solid $secondColor;
		flex-shrink: 0;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		background-image: url('/images/icon/empty.svg');
		cursor: pointer;
		@include respond(smallhight) {
			width: 102px;
			height: 102px;
		}
		& input {
			display: none;
		}
		& .placeholder {
			position: absolute;
			left: 0;
			top: 0;
			right: 0;
			bottom: 0;
			background-image: url('/images/icon/add_avatar.svg');
			background-position: center;
			background-repeat: no-repeat;
			color: #ffffff;
			opacity: 0;
			transition: 0.5s;
		}
		&:hover .placeholder {
			opacity: 1;
		}
	}
	&__form {
		display: flex;
		flex-direction: column;
		& .select {
			margin-bottom: 25px;
			width: 100%;
		}
		& .form-input {
			margin-bottom: 16px;
		}
	}
	&__buttons {
		display: flex;
		max-width: 370px;
		margin-left: auto;
		margin-right: auto;
		justify-content: space-between;
		align-items: center;
		// padding-right: 18px;
		& .button {
			width: 156px;
			color: $secondColor;
		}
	}
	&__status {
		margin-top: 15px;
		font-size: 20px;
		text-align: center;
		&--loading {
			color: $secondColor;
		}
		&--success {
			color: $primaryColor;
		}
		&--failed {
			color: red;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			& span {
				margin-bottom: 5px;
			}
		}
	}
	&-password--failed {
		font-size: 14px;
		color: red;
		text-align: center;
		margin-top: 10px;
	}
}
.v-select .dropdown-toggle {
	width: 100% !important;
}
.dropdown-toggle {
	width: 100% !important;
}
</style>
